import * as React from 'react';
import style from './HeroSection.module.css';
import LandingPageImg from '../../../assets/marketing/landing-banner1.webp';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { CONTACT_US_CALENDLY_URL } from '../../../utils/constant/constants';
import { PopupButton } from 'react-calendly';
import { useSelector } from 'react-redux';

export default function HeroSection() {
	const [isVisible, setIsVisible] = React.useState(false);
	const [isVisibleBtn, setIsVisibleBtn] = React.useState(false);

	React.useEffect(() => {
		AOS.init({ duration: 2000, once: true });
	}, []);

	React.useEffect(() => {
		// Delay observer initialization by 2 seconds
		const timeout = setTimeout(() => {
			const element = document.getElementById('slide-up-element');
			const observer = new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting) {
						setIsVisible(true);
					}
				},
				{ threshold: 0.5 }
			);

			if (element) {
				observer.observe(element);
			}

			return () => {
				if (element) observer.unobserve(element);
			};
		}, 1000); // 2-second delay

		return () => clearTimeout(timeout); // Clear timeout if component unmounts
	}, []);

	React.useEffect(() => {
		// Delay observer initialization by 2 seconds
		const timeout = setTimeout(() => {
			const element = document.getElementById('slide-up-element-btn');
			const observer = new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting) {
						setIsVisibleBtn(true);
					}
				},
				{ threshold: 0.5 }
			);

			if (element) {
				observer.observe(element);
			}

			return () => {
				if (element) observer.unobserve(element);
			};
		}, 2000); // 2-second delay

		return () => clearTimeout(timeout); // Clear timeout if component unmounts
	}, []);

	return (
		<div>
			<div className='fixed min-h-[100dvh] left-0 right-0 flex-col w-full'>
				<div className='flex justify-center items-center relative mx-auto w-full text-white uppercase min-h-[100dvh]'>
					<img
						loading='lazy'
						src={LandingPageImg}
						alt='Hero background'
						className={`${style.heroBg} `}
					/>
					<div className={style.heroOverlay}></div>
				</div>
			</div>

			<div className='relative z-10 xl:top-[260px] top-[200px]'>
				<div className='min-h-[100dvh] text-white uppercase'>
					<div className='flex bottom-1 flex-col items-center text-center max-w-full w-full max-w-[788px] p-5 pt-20'>
						<div
							id='slide-up-element'
							className={`${
								isVisible ? 'animate-slideUp' : 'opacity-0'
							} tracking-wider mt-5 max-w-[1100px] lg:max-w-[1100px] mb-[20px] text-[44px] font-bold leading-[60px] md:text-[38px] md:leading-[50px] lg:text-[46px] lg:leading-[62px] xl:text-[50px] xl:leading-[66px] mobile:text-[34px] mobile:leading-[44px] mobile:whitespace-normal smallView:text-[30px] smallView:leading-[40px] smallView:max-w-[min(340px,100%)] mobile:max-w-[460px]`}>
							<span className='font-accent uppercase'>Turn Your SOI into Steady</span>{' '}
							<span className='block md:inline text-primary md:whitespace-nowrap font-body uppercase'>
								Repeat & Referral Business
							</span>
						</div>

						<div
							id='slide-up-element'
							className={`${
								isVisible ? 'animate-slideUp' : 'opacity-0'
							} normal-case max-w-[560px] lg:max-w-[620px] mb-[30px] lg:mb-[40px] text-[22px] font-light leading-[34px] md:text-[20px] md:leading-[30px] lg:text-[24px] lg:leading-[36px] mobile:text-[18px] mobile:leading-[28px] smallView:text-[16px] smallView:leading-[26px] smallView:max-w-[min(340px,100%)] mobile:max-w-[440px]`}>
							Relationship-first marketing for real estate agents
						</div>

						<button
							id='slide-up-element-btn'
							className={`${
								isVisibleBtn ? 'animate-slideUp' : 'opacity-0'
							} font-montserrat-regular text-[16px] font-normal leading-[16px] normal-case border-[0.8px] border-[solid] border-[#FFFFFF] max-w-[220px] md:max-w-[250px] lg:max-w-[280px] w-full px-[16px] py-[20px] backdrop-filter backdrop-blur-[10px] bg-[#0000000D]`}
							tabIndex='0'>
							<PopupButton
								tabIndex='0'
								url={CONTACT_US_CALENDLY_URL}
								rootElement={document.getElementById('root')}
								text='Schedule a meeting'
							/>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
